import { render, staticRenderFns } from "./ldgh.vue?vue&type=template&id=68a046bc&scoped=true&"
import script from "./ldgh.vue?vue&type=script&lang=js&"
export * from "./ldgh.vue?vue&type=script&lang=js&"
import style0 from "./ldgh.vue?vue&type=style&index=0&id=68a046bc&scoped=true&lang=css&"
import style1 from "./ldgh.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a046bc",
  null
  
)

export default component.exports